/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_CommunicationsInputs */

const cs_nav_section_communications = /** @type {(inputs: Nav_Section_CommunicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunikace`)
};

const en_nav_section_communications = /** @type {(inputs: Nav_Section_CommunicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communications`)
};

/**
* | output |
* | --- |
* | "Communications" |
*
* @param {Nav_Section_CommunicationsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_communications = /** @type {((inputs?: Nav_Section_CommunicationsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_CommunicationsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_communications(inputs)
	return cs_nav_section_communications(inputs)
});